import { useDialog } from 'client/modules/app/dialogs/hooks/useDialog';
import { MouseEventHandler } from 'react';
import { useConnectWalletAction } from './ConnectWalletActionContext';
import { getIsLocalTestWalletShortcutEnabled } from './localTestWalletShortcut';
import { useRepeatedClickCountHandler } from './useRepeatedClickCountHandler';

export {
  getIsLocalTestWalletShortcutEnabled,
  getIsLocalTestWalletShortcutHostname,
} from './localTestWalletShortcut';

const TEST_WALLET_SHORTCUT_CLICK_COUNT = 3;
const TEST_WALLET_SHORTCUT_RESET_DELAY = 10000;

export function useConnectWalletButtonClickHandler<
  T extends Element = Element,
>(): MouseEventHandler<T> {
  const { show } = useDialog();
  const connectWallet = useConnectWalletAction<T>();

  return useRepeatedClickCountHandler<T>({
    resetDelay: TEST_WALLET_SHORTCUT_RESET_DELAY,
    handler: (count, event) => {
      const isTestWalletShortcutClick =
        event.shiftKey && getIsLocalTestWalletShortcutEnabled();

      if (isTestWalletShortcutClick) {
        event.preventDefault();
        event.stopPropagation();

        if (count === TEST_WALLET_SHORTCUT_CLICK_COUNT) {
          show({
            type: 'connect_custom_wallet',
            params: {},
          });
        }

        return;
      }

      if (connectWallet) {
        connectWallet(event);
        return;
      }

      show({
        type: 'connect',
        params: {},
      });
    },
  });
}
